import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
} from '@reduxjs/toolkit/query/react';
import { API_URL } from '../constants/urls';
import { resetAuth } from '../reducers/authSlice';
import { RootState } from '../app/store';
import { getFromStorage } from '../helpers';
import { STORAGE_KEYS } from '../constants/storagekeys';
import { USE_FAKE_DATA } from '../config/appConfig';
import { mockRequest } from '../mocks';
    
const baseQuery = fetchBaseQuery({
  baseUrl: API_URL, 
  prepareHeaders: (headers: Headers, { getState }: { getState: () => unknown }) => {
    const token = (getState() as RootState).auth.token || getFromStorage(STORAGE_KEYS.token);
    const tempToken =
      (getState() as RootState).auth.tempToken || getFromStorage(STORAGE_KEYS.tempToken);

    // const encryptData = generateSEKAndHash(token || tempToken || null);
    // headers.set('hash', encryptData?.hash);
    // headers.set('sek', encryptData?.sek);
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    } else if (tempToken) {
      headers.set('authorization', `Bearer ${tempToken}`);
    }
    headers.set('x-portal', 'admin');
    // headers.set("authorization",`Bearer ${token}`)l

    return headers;
  },

  // prepareHeaders: (headers, { getState }) => {
  //   const { token } = (getState() as RootState).auth;
  //   const { tempToken } = (getState() as RootState).auth;
  //   console.log(token,"tokennnnnnnnn");

  //   if (token) {
  //     headers.set("authorization", `Bearer ${token}`);
  //   } else if (tempToken) {
  //     headers.set("authorization", `Bearer ${tempToken}`);
  //   }
  //   headers.set("Device","WEB");
  //   // headers.set("Hash", `${encryptedData?.hash}`);
  //   // headers.set("Sek", ` ${encryptedData?.sek}`);
  // // headers.set("Device","WEB");
  //   return headers;
  // },
});

const baseQueryWithAuth: BaseQueryFn<
  string | FetchArgs | any,
  unknown,
  FetchBaseQueryError
> = async (
  args: string | FetchArgs | any,
  api: any,
  extraOptions: any
) => {
  if (USE_FAKE_DATA) {
    const method = typeof args === 'string' ? 'GET' : (args.method || 'GET');
    const url = typeof args === 'string' ? args : args.url;
    const body = typeof args === 'string' ? undefined : args.body;
    const response = await mockRequest(method, url, body);
    return { data: response.data } as any;
  }
  // if (args.body) {
  //   const encryptedData = generateEncryptedKeyBody(args.body);
  //   if (encryptedData) {
  //     args.body = encryptedData;
  //   } else {
  //     return {
  //       error: {
  //         status: 400,
  //         data: { detail: "Failed to encrypt request body" },
  //       },
  //     };
  //   }
  // }
  const result = await baseQuery(args, api, extraOptions);
  //   if(result.error?.status === 400) {
  //     const errors = Object.values(result?.error?.data || {});
  //     console.log({ errors });
  //     if (errors?.length > 1 && errors[1] === 400) {
  //       return result;
  //     }
  //     if (errors?.length) {
  //       const error = errors[0] as any;
  //       if (error?.length) {
  //         console.log(error[0]);
  //       }
  //     }
  //   }
  if (result?.error?.status === 401) {
    api.dispatch(resetAuth());
    // showError("CUSTOM ERROR")
    if (window) {
      window.location.replace('/');
    }
  }
  if (result.error && result.error.status === 401 && (api.getState() as RootState).auth.user) {
    api.dispatch(resetAuth());
  }

  return result;
};

const emptySplitApi = createApi({
  baseQuery: baseQueryWithAuth,
  tagTypes: [
    'UNAUTHORIZED',
    'UNKNOWN_ERROR',
    'PROMOCODES',
    'HOME_SECTION',
    'SUB_COMMUNITY_CATEGORY',
    'ANNOUNCMENT',
    'TOPIC',
  ],
  endpoints: () => ({}),
});

export default emptySplitApi;
